import React, { useState } from 'react';
import { startOfMonth, endOfMonth, startOfISOWeek, endOfISOWeek, eachDayOfInterval, isSameMonth, isToday, getDay } from 'date-fns';

const DAYS = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];

const MiniCalendarCard: React.FC = () => {
  const [current, setCurrent] = useState(new Date());

  const monthStart = startOfMonth(current);
  const monthEnd = endOfMonth(current);
  const gridStart = startOfISOWeek(monthStart);
  const gridEnd = endOfISOWeek(monthEnd);
  const days = eachDayOfInterval({ start: gridStart, end: gridEnd });

  const monthLabel = current.toLocaleDateString('en-GB', { month: 'long', year: 'numeric' });

  const prev = () => setCurrent(d => new Date(d.getFullYear(), d.getMonth() - 1, 1));
  const next = () => setCurrent(d => new Date(d.getFullYear(), d.getMonth() + 1, 1));

  const isWeekend = (d: Date) => { const day = getDay(d); return day === 0 || day === 6; };

  return (
    <div className="dashboard-card" style={{ padding: 16 }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-color)' }}>{monthLabel}</div>
        <div style={{ display: 'flex', gap: 4 }}>
          {[['‹', prev], ['›', next]].map(([label, fn]) => (
            <button
              key={label as string}
              type="button"
              onClick={fn as () => void}
              style={{
                width: 24, height: 24, borderRadius: 7, border: '1px solid var(--border-new)',
                background: 'var(--surface2)', color: 'var(--text-color-calendar)',
                fontSize: 13, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                transition: 'all .12s',
              }}
            >
              {label as string}
            </button>
          ))}
        </div>
      </div>

      {/* Grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 2 }}>
        {/* Day headers */}
        {DAYS.map(d => (
          <div key={d} style={{ fontSize: 9, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.05em', color: 'var(--text-color-calendar-week)', textAlign: 'center', paddingBottom: 6 }}>
            {d}
          </div>
        ))}
        {/* Day cells */}
        {days.map(day => {
          const inMonth = isSameMonth(day, current);
          const today = isToday(day);
          const weekend = isWeekend(day);

          return (
            <div
              key={day.toISOString()}
              style={{
                aspectRatio: '1',
                borderRadius: 7,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 11,
                cursor: 'pointer',
                transition: 'all .1s',
                opacity: (!inMonth || weekend) ? (today ? 1 : 0.3) : 1,
                background: today
                  ? 'linear-gradient(135deg, #2563eb, #7c3aed)'
                  : 'transparent',
                color: today ? 'white' : 'var(--text-color-calendar)',
                fontWeight: today ? 800 : 400,
                boxShadow: today ? '0 2px 8px rgba(37,99,235,.35)' : 'none',
              }}
              onMouseEnter={e => { if (!today) (e.currentTarget as HTMLElement).style.background = 'var(--hover-new)'; }}
              onMouseLeave={e => { if (!today) (e.currentTarget as HTMLElement).style.background = 'transparent'; }}
            >
              {day.getDate()}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MiniCalendarCard;
